var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            "before-close": _vm.handleClose,
            title: _vm.fromData.title,
            visible: _vm.dialogVisible,
            width: "680px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c("div", { staticClass: "body" }, [
            _c(
              "div",
              { staticClass: "add-button" },
              [
                _c("p", [_vm._v("空间名称")]),
                _vm._v(" "),
                _c("el-input", {
                  staticClass: "search-input",
                  attrs: {
                    disabled: _vm.fromData.edit === 2 && !_vm.spaceButton,
                    placeholder: _vm.$t("file.placeholder03"),
                    maxlength: "20",
                    size: "small",
                  },
                  model: {
                    value: _vm.name,
                    callback: function ($$v) {
                      _vm.name = $$v
                    },
                    expression: "name",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content" },
              [
                _c("ul", { staticClass: "content-title" }, [
                  _c("li", [
                    _c(
                      "p",
                      { staticClass: "text-left" },
                      [
                        _c("select-member", {
                          ref: "selectMember",
                          attrs: { value: _vm.userList || [] },
                          on: {
                            getSelectList: function ($event) {
                              return _vm.getSelectList($event, 1)
                            },
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "custom",
                              fn: function () {
                                return [
                                  _c(
                                    "el-button",
                                    {
                                      attrs: {
                                        disabled:
                                          _vm.fromData.edit === 2 &&
                                          !_vm.spaceButton,
                                        icon: "el-icon-plus",
                                        type: "text",
                                      },
                                      on: {
                                        click: function ($event) {
                                          $event.stopPropagation()
                                          return _vm.openDepartment(1)
                                        },
                                      },
                                    },
                                    [_vm._v("\n                    添加成员")]
                                  ),
                                ]
                              },
                              proxy: true,
                            },
                          ]),
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "p",
                      [
                        _c("el-checkbox", {
                          attrs: { disabled: true },
                          on: {
                            change: function ($event) {
                              return _vm.handleChange(1)
                            },
                          },
                          model: {
                            value: _vm.lookCheck,
                            callback: function ($$v) {
                              _vm.lookCheck = $$v
                            },
                            expression: "lookCheck",
                          },
                        }),
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.$t("public.check")) +
                            "\n            "
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "p",
                      [
                        _c("el-checkbox", {
                          attrs: {
                            disabled:
                              _vm.userList.length <= 0 ||
                              (_vm.fromData.edit === 2 && !_vm.spaceButton),
                          },
                          on: {
                            change: function ($event) {
                              return _vm.handleChange(2)
                            },
                          },
                          model: {
                            value: _vm.createCheck,
                            callback: function ($$v) {
                              _vm.createCheck = $$v
                            },
                            expression: "createCheck",
                          },
                        }),
                        _vm._v(
                          _vm._s(_vm.$t("public.establish")) + "\n            "
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "p",
                      [
                        _c("el-checkbox", {
                          attrs: {
                            disabled:
                              _vm.userList.length <= 0 ||
                              (_vm.fromData.edit === 2 && !_vm.spaceButton),
                          },
                          on: {
                            change: function ($event) {
                              return _vm.handleChange(3)
                            },
                          },
                          model: {
                            value: _vm.editCheck,
                            callback: function ($$v) {
                              _vm.editCheck = $$v
                            },
                            expression: "editCheck",
                          },
                        }),
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.$t("public.edit")) +
                            "\n            "
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "p",
                      [
                        _c("el-checkbox", {
                          attrs: {
                            disabled:
                              _vm.userList.length <= 0 ||
                              (_vm.fromData.edit === 2 && !_vm.spaceButton),
                          },
                          on: {
                            change: function ($event) {
                              return _vm.handleChange(4)
                            },
                          },
                          model: {
                            value: _vm.downloadCheck,
                            callback: function ($$v) {
                              _vm.downloadCheck = $$v
                            },
                            expression: "downloadCheck",
                          },
                        }),
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.$t("public.download")) +
                            "\n            "
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "p",
                      [
                        _c("el-checkbox", {
                          attrs: {
                            disabled:
                              _vm.userList.length <= 0 ||
                              (_vm.fromData.edit === 2 && !_vm.spaceButton),
                          },
                          on: {
                            change: function ($event) {
                              return _vm.handleChange(5)
                            },
                          },
                          model: {
                            value: _vm.deleteCheck,
                            callback: function ($$v) {
                              _vm.deleteCheck = $$v
                            },
                            expression: "deleteCheck",
                          },
                        }),
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.$t("public.delete")) +
                            "\n            "
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("p", [
                      _vm._v(
                        "\n              " +
                          _vm._s(_vm.$t("public.operation")) +
                          "\n            "
                      ),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c("el-scrollbar", { staticStyle: { height: "40vh" } }, [
                  _c(
                    "ul",
                    { staticClass: "content-body" },
                    _vm._l(_vm.userList, function (item, index) {
                      return _c(
                        "li",
                        { key: index },
                        [
                          _c("p", { staticClass: "username" }, [
                            _c("img", {
                              attrs: {
                                src: item.card ? item.card.avatar : item.avatar,
                                alt: "",
                              },
                            }),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(
                                _vm._s(item.card ? item.card.name : item.name)
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c(
                            "p",
                            [
                              _c("el-checkbox", {
                                attrs: { disabled: true },
                                model: {
                                  value: item.lookCheck,
                                  callback: function ($$v) {
                                    _vm.$set(item, "lookCheck", $$v)
                                  },
                                  expression: "item.lookCheck",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          index === 0
                            ? [
                                _c(
                                  "p",
                                  [
                                    _c("el-checkbox", {
                                      attrs: {
                                        disabled: _vm.fromData.edit === 2,
                                        label: item.createCheck,
                                      },
                                      model: {
                                        value: item.createCheck,
                                        callback: function ($$v) {
                                          _vm.$set(item, "createCheck", $$v)
                                        },
                                        expression: "item.createCheck",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "p",
                                  [
                                    _c("el-checkbox", {
                                      attrs: {
                                        disabled: _vm.fromData.edit === 2,
                                        label: item.editCheck,
                                      },
                                      model: {
                                        value: item.editCheck,
                                        callback: function ($$v) {
                                          _vm.$set(item, "editCheck", $$v)
                                        },
                                        expression: "item.editCheck",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "p",
                                  [
                                    _c("el-checkbox", {
                                      attrs: {
                                        disabled: _vm.fromData.edit === 2,
                                        label: item.downloadCheck,
                                      },
                                      model: {
                                        value: item.downloadCheck,
                                        callback: function ($$v) {
                                          _vm.$set(item, "downloadCheck", $$v)
                                        },
                                        expression: "item.downloadCheck",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "p",
                                  [
                                    _c("el-checkbox", {
                                      attrs: {
                                        disabled: _vm.fromData.edit === 2,
                                        label: item.deleteCheck,
                                      },
                                      model: {
                                        value: item.deleteCheck,
                                        callback: function ($$v) {
                                          _vm.$set(item, "deleteCheck", $$v)
                                        },
                                        expression: "item.deleteCheck",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            : [
                                _c(
                                  "p",
                                  [
                                    _c("el-checkbox", {
                                      attrs: {
                                        disabled:
                                          _vm.fromData.edit === 2 &&
                                          !_vm.spaceButton,
                                        label: item.createCheck,
                                      },
                                      model: {
                                        value: item.createCheck,
                                        callback: function ($$v) {
                                          _vm.$set(item, "createCheck", $$v)
                                        },
                                        expression: "item.createCheck",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "p",
                                  [
                                    _c("el-checkbox", {
                                      attrs: {
                                        disabled:
                                          _vm.fromData.edit === 2 &&
                                          !_vm.spaceButton,
                                        label: item.editCheck,
                                      },
                                      model: {
                                        value: item.editCheck,
                                        callback: function ($$v) {
                                          _vm.$set(item, "editCheck", $$v)
                                        },
                                        expression: "item.editCheck",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "p",
                                  [
                                    _c("el-checkbox", {
                                      attrs: {
                                        disabled:
                                          _vm.fromData.edit === 2 &&
                                          !_vm.spaceButton,
                                        label: item.downloadCheck,
                                      },
                                      model: {
                                        value: item.downloadCheck,
                                        callback: function ($$v) {
                                          _vm.$set(item, "downloadCheck", $$v)
                                        },
                                        expression: "item.downloadCheck",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "p",
                                  [
                                    _c("el-checkbox", {
                                      attrs: {
                                        disabled:
                                          _vm.fromData.edit === 2 &&
                                          !_vm.spaceButton,
                                        label: item.deleteCheck,
                                      },
                                      model: {
                                        value: item.deleteCheck,
                                        callback: function ($$v) {
                                          _vm.$set(item, "deleteCheck", $$v)
                                        },
                                        expression: "item.deleteCheck",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                          _vm._v(" "),
                          _c(
                            "p",
                            [
                              _vm.fromData.edit === 2 && index === 0
                                ? [
                                    _c("select-member", {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: _vm.spaceButton,
                                          expression: "spaceButton",
                                        },
                                      ],
                                      ref: "member",
                                      refInFor: true,
                                      attrs: {
                                        "only-one": true,
                                        value: [_vm.userList[0]] || [],
                                      },
                                      on: {
                                        getSelectList: function ($event) {
                                          return _vm.getSelectList($event, 2)
                                        },
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "custom",
                                            fn: function () {
                                              return [
                                                _c(
                                                  "el-button",
                                                  {
                                                    attrs: { type: "text" },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.openDepartment(
                                                          2
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [_vm._v("转让管理员")]
                                                ),
                                              ]
                                            },
                                            proxy: true,
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                    _vm._v(" "),
                                    !_vm.spaceButton
                                      ? _c(
                                          "span",
                                          { attrs: { type: "text" } },
                                          [_vm._v("管理员")]
                                        )
                                      : _vm._e(),
                                  ]
                                : [
                                    _vm.spaceButton
                                      ? _c(
                                          "el-button",
                                          {
                                            attrs: { type: "text" },
                                            on: {
                                              click: function ($event) {
                                                return _vm.deleteShare(index)
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.$t("public.delete"))
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ],
                            ],
                            2
                          ),
                        ],
                        2
                      )
                    }),
                    0
                  ),
                ]),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer text-right",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                { attrs: { size: "small" }, on: { click: _vm.handleClose } },
                [_vm._v(_vm._s(_vm.$t("public.cancel")))]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { size: "small", type: "primary" },
                  on: { click: _vm.handleAdd },
                },
                [_vm._v(_vm._s(_vm.$t("public.ok")))]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }